export const emailMasking = (email: string) => {
    const atIndex = email.indexOf("@");
    if (atIndex === -1) return email;
  
    const localPart = email.substring(0, atIndex);
    const domainPart = email.substring(atIndex);
  
    let maskedLocalPart = "";
    if (localPart.length > 2) {
      const firstTwoChars = localPart.substring(0, 2);
      const remainingChars = localPart.substring(2);
      const visibleChar = remainingChars.charAt(0);
      const maskedChars = remainingChars.substring(1).replace(/./g, "*");
      maskedLocalPart = `${firstTwoChars}***${visibleChar}${maskedChars}`;
    } else {
      maskedLocalPart = localPart;
    }
  
    return `${maskedLocalPart}${domainPart}`;
  };
  
  export const mobileNumberMasking = (phoneNumber: string) => {
    const cleaned = phoneNumber.replace(/\D/g, "");
    const length = cleaned.length;
    if (length <= 4) {
      return phoneNumber;
    }
    const masked = "*".repeat(length - 4) + cleaned.slice(-4);
    return masked;
  };
  